export default __webpack_public_path__ + "static/media/1979.18658490.png";